import {
  Th,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  Flex,
  Checkbox,
  Box,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react'

import { CheckIcon } from '@chakra-ui/icons'
import React from 'react'
import { HiOutlineDotsHorizontal } from 'react-icons/hi'

export const RowText = ({ children }: { children: React.ReactNode }) => (
  <Text fontFamily="Inter" fontWeight={500} fontSize="12px" color="#484848">
    {children}
  </Text>
)

export const HeaderText = ({
  children,
  textAlign,
  isNumeric,
}: {
  children: React.ReactNode
  textAlign?: 'center' | 'end' | 'justify' | 'left' | 'match-parent' | 'right' | 'start'
  isNumeric?: boolean
}) => (
  <Th
    fontFamily="Inter"
    fontWeight={400}
    fontSize="11px"
    color="#9B9B9B"
    textAlign={textAlign}
    isNumeric={isNumeric}
  >
    {children}
  </Th>
)

export const DeviceNamesCell = ({
  devices,
}: {
  devices: { id: number; title: string }[]
}) => {
  const names = (devices ?? []).map((d) => d.title)
  const MAX_VISIBLE = 3
  const extra = Math.max(0, names.length - MAX_VISIBLE)

  return (
    <Flex gap="5px" align="center" wrap="wrap">
      {names.slice(0, MAX_VISIBLE).map((x, i) => (
        <Text
          key={`${x}-${i}`}
          fontFamily="Inter"
          fontWeight={500}
          fontSize="12px"
          color="#484848"
        >
          {x}
          {names.length - 1 !== i ? ',' : ''}
        </Text>
      ))}

      {extra > 0 && (
        <Popover trigger="hover" placement="top-start">
          <PopoverTrigger>
            <Text
              fontFamily="Inter"
              fontWeight={500}
              fontSize="12px"
              color="#707070"
              cursor="default"
              _hover={{ textDecoration: 'underline' }}
            >
              + {extra} more
            </Text>
          </PopoverTrigger>
          <PopoverContent w="auto" maxW="420px" _focus={{ boxShadow: 'none' }}>
            <PopoverArrow />
            <PopoverBody>
              <Box maxH="260px" overflowY="auto">
                {names.map((x, i) => (
                  <Text key={`${x}-full-${i}`} fontSize="sm" py="2px">
                    {x}
                    {names.length - 1 !== i ? ',' : ''}
                  </Text>
                ))}
              </Box>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      )}
    </Flex>
  )
}

export const DeviceCheckbox: React.FC<React.ComponentProps<typeof Checkbox>> = (
  props,
) => (
  <Checkbox
    icon={<CheckIcon boxSize="12px" />}
    size="lg"
    sx={{
      '.chakra-checkbox__control': {
        w: '22px',
        h: '22px',
        borderRadius: '6px',
        borderColor: '#D0D5DD',
        bg: 'white',
        _checked: {
          bg: 'blue.500',
          borderColor: 'blue.500',
          color: 'white',
          _hover: { bg: 'blue.500' },
        },
        _hover: { borderColor: '#D0D5DD' },
        _focusVisible: { boxShadow: 'none' },
      },
      '.chakra-checkbox__label': {
        marginLeft: '12px',
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 400,
      },
    }}
    {...props}
  />
)

export const KebabMenu = ({
  onEdit,
  onRemove,
}: {
  onEdit: () => void
  onRemove: () => void
}) => (
  <Menu placement="bottom-end" isLazy>
    <MenuButton
      as={IconButton}
      aria-label="options"
      icon={<HiOutlineDotsHorizontal />}
      sx={{
        w: '32px',
        h: '32px',
        borderRadius: 'md',
        _hover: { bg: '#F2F4F7' },
        _focus: { boxShadow: 'none' },
        _active: { bg: '#F2F4F7' },
        _expanded: { bg: '#F2F4F7' },
        boxShadow: 'none',
      }}
      variant="ghost"
    />
    <MenuList
      p={0}
      minW="140px"
      bg="white"
      border="1px solid #F2F4F7"
      boxShadow="0px 8px 24px rgba(16, 24, 40, 0.08)"
      borderRadius="md"
    >
      <MenuItem
        onClick={onEdit}
        borderRadius="md"
        fontSize="14px"
        fontWeight={500}
        color="#111827"
        _hover={{ bg: '#F3F4F6' }}
        _focus={{ bg: '#F3F4F6' }}
      >
        Edit
      </MenuItem>
      <MenuItem
        onClick={onRemove}
        borderRadius="md"
        fontSize="14px"
        fontWeight={500}
        color="red.500"
        _hover={{ bg: '#F3F4F6', color: 'red.600' }}
        _focus={{ bg: '#F3F4F6' }}
      >
        Remove
      </MenuItem>
    </MenuList>
  </Menu>
)
